module.exports = __webpack_public_path__ + "img/vc.60113cb8.svg";